<template>
    <Card class="col-span-12 md:col-span-2">
        <template #content>
            <div class="text-xs font-semibold uppercase text-gray-600">
                {{ title }}
            </div>
            <div class="flex items-center justify-start gap-2">
                <div class="text-2xl font-bold">
                    {{ currentValue ?? 0 }}
                </div>
                <div>
                    <Icon
                        v-if="currentValue > previousValue"
                        name="arrow-up"
                        class="w-3 h-3 text-active"
                    />
                    <Icon
                        v-else-if="currentValue < previousValue"
                        name="arrow-down"
                        class="w-3 h-3 text-error"
                    />
                </div>
            </div>
        </template>
    </Card>
</template>

<script setup lang="ts">
    import Card from '@/Shared/Component/Card.vue'
    import Icon from '@/Shared/Component/Icon.vue'

    const props = defineProps({
        title: {
            type: String,
            required: true,
        },
        currentValue: {
            type: Number,
            default: null,
        },
        previousValue: {
            type: Number,
            default: null,
        },
    })
</script>
